import { z } from 'zod';

export const productFiltersSchema = z.object({
  label: z.string().min(1),
  value: z.string().regex(/^[a-zA-Z0-9_]+$/)
});
